import { MDBBtn, MDBChip, MDBIcon, MDBSelect } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getMisc, updateSMSGroup } from "../../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";
import TelephoneNumbers from "../../TelephoneNumbers";
import { formattedNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";

function SMSGenralSettings({
  register,
  watch,
  errors,
  setValue,
  smsDIDs,
  setSuccessMessage,
  setRerender,
  code,
  setIsloading,
}) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [AddNumbers, setAddNumbers] = useState(false);
  const toggleShow12 = () => setAddNumbers(!AddNumbers);
  const [allLocations, setAllLocations] = useState([]);
  const [billingGroupList, setBillingGroupList] = useState([]);
  const [didList, setdidList] = useState([]);
  const [dbPhoneNumbers, setdbPhoneNumbers] = useState([]);
  const [updatePHNum, setUpdatePHNum] = useState([]);
  const [freePhoneFlag, setfreePhoneFlag] = useState(true);
  const [sourceNumber, setSourceNumber] = useState([]);
  const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);
  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
  const [error, setError] = useState({});

  useEffect(() => {
    if (smsDIDs && smsDIDs.length > 0) {
      setdidList(smsDIDs);
      setdbPhoneNumbers(smsDIDs);
    }
  }, [smsDIDs]);

  async function fetchData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      {
        misc: ["all_locations", "billinggroups"],
      }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    setAllLocations(
      tdata.misc.all_locations.map((item) => ({
        ...item,
        loc_id: parseInt(item.loc_id, 10), // Ensure id is a number
      }))
    );
    setBillingGroupList(
      tdata.misc.billinggroups.map((item) => ({
        ...item,
        groupid: parseInt(item.groupid, 10), // Ensure id is a number
      }))
    );
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (freePhoneFlag) {
      getFreePhoneNumbers();
      setfreePhoneFlag(false);
    }
  }, [freePhoneFlag]);

  async function getFreePhoneNumbers() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["sms_dids"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log(
      "response SMS Dids data is :::::::::: " + JSON.stringify(basicInfo)
    );
    setSourceNumber(basicInfo.misc.sms_dids);
  }

  useEffect(() => {
    if (updatePHNum.length > 0 && updateNumbersExecuted) {
      addPhoneNumbers("adddids");
      setUpdateNumbersExecuted(false);
    }
  }, [updatePHNum, updateNumbersExecuted]);

  useEffect(() => {
    if (updatePHNum.length > 0 && deleteNumberFlag) {
      addPhoneNumbers("removedids");
      setDeleteNumberFlag(false);
    }
  }, [updatePHNum, deleteNumberFlag]);

  async function addPhoneNumbers(fieldName) {
    setIsloading(true);
    let update = {
      reqid: 100,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      code: code,
      [fieldName]: updatePHNum,
    };

    console.log(JSON.stringify(update));
    console.log(JSON.stringify(update));
    let saverep = await updateSMSGroup(update);
    console.log(saverep);
    let saverepeMsg = await saverep.json();
    console.log(
      "reponse for add numbers ::::::::::: " + JSON.stringify(saverepeMsg)
    );
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      if (fieldName === "adddids") {
        setdidList((prev) => [...prev, ...updatePHNum]);
        setdbPhoneNumbers((prev) => [...prev, ...updatePHNum]);
        setSuccessMessage(`SMS Number ${updatePHNum} added successfully.`);
        setRerender(true);
      } else {
        const updateAddPHNum = didList.filter(
          (num) => !updatePHNum.includes(num)
        );
        setdidList(updateAddPHNum);
        setdbPhoneNumbers(updateAddPHNum);
        setSuccessMessage(`SMS Number ${updatePHNum} removed successfully.`);
        setRerender(true);
      }
      setfreePhoneFlag(true);
    } else {
      if (fieldName === "removedids") {
        const modifynum = didList.filter((num) => !updatePHNum.includes(num));
        setdidList([...modifynum, ...updatePHNum]);
        setdbPhoneNumbers([...modifynum, ...updatePHNum]);
      }
      if (saverepeMsg.message?.errors) {
        saverepeMsg.message.errors.forEach((err) => {
          setError(err.param_name, {
            type: "server",
            message: err.message,
          });
          const fieldElement = document.querySelector(
            `input[name="${err.param_name}"]`
          );
          if (fieldElement) {
            fieldElement.focus();
          }
        });
      }
    }
    setIsloading(false);
  }

  return (
    <>
      <div className="general-settings">{t("general")}</div>
      <TelephoneNumbers
        savedPhoneNumbers={didList}
        setSavedPhoneNumbers={setdidList}
        setSuccessMessage={setSuccessMessage}
        uniqueid={null}
        setUpdatePHNum={setUpdatePHNum}
        setUpdateNumbersExecuted={setUpdateNumbersExecuted}
        sourceNumber={sourceNumber}
        setDeleteNumberFlag={setDeleteNumberFlag}
        smsGroupFlag={true}
        dbPhoneNumbers={dbPhoneNumbers}
      />
      <div className="add-numbermain">
        <div className="tel-numbers">{t("primarysmsDID")}</div>
        <div className="flex-column-sm d-flex w-30">
          <div className="me-2 w-100">
            <select
              class="form-control form-select selectname w-100"
              {...register("primary_did")}
            >
              {didList &&
                didList.length > 0 &&
                didList.map((phone) => <option value={phone}>{formattedNumber(phone)}</option>)}
            </select>
          </div>
        </div>
      </div>

      <div className="add-numbermain">
        <div>Allow users to change SMS DID</div>
        <div className="phoneselect">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              {...register("allow_user_tochange_smsdid")}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("location")}</div>
        <div class="d-flex w-30">
          <div class="phoneselect w-100">
            <select
              class="form-control form-select selectname w-100"
              name="loc_id"
              value={parseInt(watch("loc_id"))}
              onChange={(e) =>
                setValue("loc_id", e.target.value, { shouldDirty: true })
              }
            >
              <option value="">Select Location</option>
              {allLocations &&
                allLocations.length > 0 &&
                allLocations.map((loc) => (
                  <option value={parseInt(loc.loc_id)}>{loc.loc_name}</option>
                ))}
            </select>
            {errors.loc_id && (
              <p className="text-danger">{errors.loc_id.message}</p>
            )}
          </div>
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("billing_Groups")}</div>
        <div className="w-30">
          <select
            class="form-control form-select selectname w-100"
            name="billing_grp"
            value={parseInt(watch("billing_grp"))}
            onChange={(e) =>
              setValue("billing_grp", parseInt(e.target.value), {
                shouldDirty: true,
              })
            }
          >
            {billingGroupList &&
              billingGroupList.map((bgrp) => (
                <option value={bgrp.groupid}>{bgrp.groupname}</option>
              ))}
          </select>
        </div>
      </div>
    </>
  );
}

export default SMSGenralSettings;
